// Path: src\Components\Contest\contestDetailTabs\contestPlayersTab.jsx

import { React, useCallback, useEffect, useRef, useState } from "react";
import Diamond from "../../../images/Diamond.png";
import kills from "../../../images/kills.png";
import userimg from "../../../images/user.png";
import ranksimg from "../../../images/ranks.png";
import premiumicon from "../../../images/premium.png";
import trophyimg from "../../../images/trophyimg.png";
import { contestPlayers } from "../../../api/contest.api";
import { url } from "../../../config/url";
import { useNavigate } from "react-router";
import ListLoader from "../../Common/ListLoader";
import { t } from "i18next";

const ContestPlayerTab = ({ contestId, contestDetails }) => {
  const profile = JSON?.parse(localStorage.getItem("profile"));
  const [playerList, setPlayerList] = useState([]);
  const [captain, setCaptainInfo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);
  const fetchPlayerDetails = async () => {
    try {
      const res = await contestPlayers(contestId, {
        search: { user: profile?.user_id },
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "rank",
          sortDirection: "asc",
        },
      });
      if (res?.success && res?.data) {
        setTotalPages(res?.totalPages);
        setPlayerList([...playerList, ...res?.data]);
        setCaptainInfo(res?.captainData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  //infinite scroll
  const loadMore = async () => {
    setLoading(true);
    fetchPlayerDetails();
  };
  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );
  return (
    <>
      <div className="tournament-players-tab custome-tournament-players-tab">
        {playerList?.length > 0 || captain ? (
          <>
            <div className="tournament-players-tab-wrap position-fixed">
              <div className="player-header">
                <div className="player-header-item">
                  <img
                    className="players-table-img"
                    src={userimg}
                    alt="User Icon"
                  />
                  <span>username</span>
                </div>
                <div className="player-header-item">
                  <img
                    className="players-table-img"
                    src={kills}
                    alt="Kills Icon"
                  />
                  <span>kills</span>
                </div>
                <div className="player-header-item">
                  <img
                    className="players-table-img"
                    src={ranksimg}
                    alt="Ranks Icon"
                  />
                  <span>ranks</span>
                </div>
              </div>
            </div>
            {/* <div className="tournament-detail-playertable"> */}
            <div className="tab-players scroll-none">
              {captain ? (
                <>
                  {/* onClick={() => navigate('/user-profile/' + captain?._id)}   redirect link but captain not redirect */}
                  <div className="player-row" key={captain._id}>
                    <div className="player-row-item">
                      <span>
                        {captain?.gamerjiName.length > 15 ? (
                          <marquee>{captain?.gamerjiName}</marquee>
                        ) : (
                          captain?.gamerjiName
                        )}

                        {/* {captain?.gamerjiName} */}
                      </span>
                      {captain?.isPremium ? (
                        <img
                          className="players-table-img"
                          src={premiumicon}
                          alt="Premium Icon"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="player-row-item">
                      <span>{captain?.kills === 0 ? "-" : captain?.kills}</span>
                      {captain?.totalMultiplierAmount > 0 ? (
                        <div className="player-win-info">
                          <img
                            className="players-table-img-won"
                            src={trophyimg}
                            alt="Trophy Icon"
                          />
                          <span>won</span>{" "}
                          <span>{captain?.totalMultiplierAmount}</span>
                          <img
                            className="players-table-img-won"
                            src={
                              url?.IMAGE_URL +
                              contestDetails?.contestFor[0]?.outCurrencyInfo
                                ?.img?.default
                            }
                            alt=""
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="player-row-item">
                      <span>{captain?.rank === 0 ? "-" : captain?.rank}</span>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              {playerList &&
                playerList?.map((player, index) => {
                  return (
                    <>
                      <div
                        className="player-row"
                        key={player._id}
                        ref={
                          playerList?.length === index + 1
                            ? lastPostElementRef
                            : null
                        }
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   navigate("/user-profile/" + player?.userId)
                        // }
                      >
                        <div className="player-row-item">
                          <span>
                            {player?.gamerjiName.length > 15 ? (
                              <marquee>{player?.gamerjiName}</marquee>
                            ) : (
                              player?.gamerjiName
                            )}
                            {/* {player?.gamerjiName} */}
                          </span>
                          {player?.isPremium ? (
                            <img
                              className="players-table-img"
                              src={premiumicon}
                              alt="Premium Icon"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="player-row-item">
                          <span>
                            {player?.kills === 0 ? "-" : player?.kills}
                          </span>
                          {/* {
                      player?.totalMultiplierAmount > 0 ?
                        <div className="player-win-info">
                          <img className="players-table-img-won" src={trophyimg} alt="Trophy Icon" />
                          <span>won</span> <span>{captain?.totalMultiplierAmount}</span>
                          <img className="players-table-img-won" src={url?.IMAGE_URL + contestDetails?.contestFor[0]?.outCurrencyInfo?.img?.default} alt="" />
                        </div> : <></>
                    } */}
                        </div>
                        <div className="player-row-item">
                          <span>{player?.rank === 0 ? "-" : player?.rank}</span>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </>
        ) : (
          !loading && (
            <>
              <div className="w-100 d-flex justify-content-center no-record-found-center">
                <span className="text-center">{t("common.no_data_found")}</span>
              </div>
            </>
          )
        )}
        {loading && (
          <div className="w-100 d-flex justify-content-center no-record-found-center">
            {" "}
            <ListLoader />
          </div>
        )}
      </div>
    </>
  );
};
export default ContestPlayerTab;
